/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Sendertopicconnectionstring3Inputs */

const en_entity_sendertopicconnectionstring3 = /** @type {(inputs: Entity_Sendertopicconnectionstring3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender Topic Connection String`)
};

const de_entity_sendertopicconnectionstring3 = /** @type {(inputs: Entity_Sendertopicconnectionstring3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender Topic Verbindungszeichenfolge`)
};

/**
* | output |
* | --- |
* | "Sender Topic Connection String" |
*
* @param {Entity_Sendertopicconnectionstring3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_sendertopicconnectionstring3 = /** @type {((inputs?: Entity_Sendertopicconnectionstring3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Sendertopicconnectionstring3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_sendertopicconnectionstring3(inputs)
	return de_entity_sendertopicconnectionstring3(inputs)
});
export { entity_sendertopicconnectionstring3 as "entity_senderTopicConnectionString" }